<template>
  <a href="/#Contact" class="discussBtn" @click="redirectform()">
    {{ $t('discuss') }}
    <img class="discussImg" src="../assets/discussIcon.png" alt="chat">
    <div class="clear"></div>
  </a>
</template>

<script>
export default {
  name: 'discussBtn',
  methods: {
    redirectform() {
      this.$store.dispatch('openContact', 1)
      // this.$router.push({ path: '/#Contact' })
      this.$router.push("/#Contact").catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.discussBtn {
  color:white;
  background: linear-gradient(160deg, #772174 -25%, #FF2247 100%);
  padding:5px 10px;
  /* margin: 0 40px; */
  border-radius: 5px;
  display:inline-block;
  width:184px;
  animation: 2s linear 0s alternate move_eye;
}


@-webkit-keyframes move_eye { from { opacity:0 } to { opacity:1 }  }
        @keyframes move_eye { from { opacity:0 } to { opacity:1 }  }

.discussBtn img {
  padding-left: 5px;
  float:right;
}

.discussBtn:hover {
  color:white;
}

</style>
